export default __webpack_public_path__ + "static/media/qr-sobrepuesto.1c82dd3b.png";